module.exports = __webpack_public_path__ + "img/library.5ece9fe1.svg";